import { useLocation } from 'react-router';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { DURATION_SLOW, EASE_OUT, useReducedMotion, reduceMotion } from '@/lib/motion';
import { useTenantPath } from '@/lib/auth/TenantCodeContext';

export function DashboardIcon({ className }: { className?: string; style?: React.CSSProperties }) {
  const location = useLocation();
  const prefersReduced = useReducedMotion();
  const dashboardPath = useTenantPath('/dashboard');
  const isActive = location.pathname === dashboardPath || location.pathname.startsWith(dashboardPath + '/');

  return (
    <motion.i
      animate={{ rotate: isActive ? 90 : 0 }}
      transition={reduceMotion(prefersReduced, { duration: DURATION_SLOW, ease: EASE_OUT })}
      className={cn('pi pi-th-large', '[font-size:var(--sidebar-icon-size)]', className)}
      aria-hidden="true"
    />
  );
}
